import { render } from "./Install.vue?vue&type=template&id=324ef5d9"
import script from "./Install.vue?vue&type=script&lang=js"
export * from "./Install.vue?vue&type=script&lang=js"

import "./Install.vue?vue&type=style&index=0&id=324ef5d9&lang=scss"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__